import { render, staticRenderFns } from "./BillPage.vue?vue&type=template&id=e451ef72&scoped=true&"
import script from "./BillPage.vue?vue&type=script&lang=js&"
export * from "./BillPage.vue?vue&type=script&lang=js&"
import style0 from "./BillPage.vue?vue&type=style&index=0&id=e451ef72&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e451ef72",
  null
  
)

export default component.exports